window.jQuery = require('jquery');

import PDFObject from 'pdfobject';
// console.log('#pdfContainer');
jQuery(function ($) {
    // console.log($('#pdfContainer'));
    if ($('#pdfContainer').length) {
        const pdfFile = $('#pdfContainer').data('pdf-file');
        PDFObject.embed(pdfFile, "#pdfContainer");
    }
});
